import { useState, useEffect } from 'react';

const CountdownTimer = ({ endDate, compact = false }) => {
  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

  function calculateTimeLeft() {
    const end = new Date(endDate);
    const now = new Date();
    const difference = end - now;

    if (difference <= 0) {
      return { days: 0, hours: 0, minutes: 0, seconds: 0, ended: true };
    }

    return {
      days: Math.floor(difference / (1000 * 60 * 60 * 24)),
      hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
      minutes: Math.floor((difference / 1000 / 60) % 60),
      seconds: Math.floor((difference / 1000) % 60),
      ended: false
    };
  }

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);

    return () => clearInterval(timer);
  }, [endDate]);

  if (timeLeft.ended) {
    return (
      <span className={`text-red-500 font-semibold ${compact ? 'text-sm' : 'text-lg'}`}>
        Ended
      </span>
    );
  }

  if (compact) {
    if (timeLeft.days > 0) {
      return (
        <span className="text-neutral-600 font-medium">
          {timeLeft.days}d {timeLeft.hours}h left
        </span>
      );
    }
    return (
      <span className="text-[#FF3B30] font-semibold urgency-pulse">
        {timeLeft.hours}h {timeLeft.minutes}m left
      </span>
    );
  }

  return (
    <div className="flex items-center gap-3">
      <div className="text-center">
        <div className="countdown-box">{String(timeLeft.days).padStart(2, '0')}</div>
        <span className="text-xs text-white/60 mt-1 block">Days</span>
      </div>
      <span className="text-2xl text-white/40">:</span>
      <div className="text-center">
        <div className="countdown-box">{String(timeLeft.hours).padStart(2, '0')}</div>
        <span className="text-xs text-white/60 mt-1 block">Hours</span>
      </div>
      <span className="text-2xl text-white/40">:</span>
      <div className="text-center">
        <div className="countdown-box">{String(timeLeft.minutes).padStart(2, '0')}</div>
        <span className="text-xs text-white/60 mt-1 block">Mins</span>
      </div>
      <span className="text-2xl text-white/40">:</span>
      <div className="text-center">
        <div className="countdown-box urgency-pulse">{String(timeLeft.seconds).padStart(2, '0')}</div>
        <span className="text-xs text-white/60 mt-1 block">Secs</span>
      </div>
    </div>
  );
};

export default CountdownTimer;
